// extracted by mini-css-extract-plugin
module.exports = {"accomplishment":"AccomplishmentsBox_accomplishment__IQ9YF","description":"AccomplishmentsBox_description__mSlXW","title":"AccomplishmentsBox_title__VSYeZ"};